import { EspAccountWithCustomMTAConfig } from 'modules/graphql/types';
import { Skeleton } from 'ui/skeleton';
import { CustomPushDestination } from './CustomPushDestination';
import { CustomPushDestinationsEmptyState } from './CustomPushDestinationsEmptyState';
import { CUSTOM_PUSH } from '../../../constants';
import { mockCustomPushAccount } from '../../../mockData';
import { useSendingPlatformsQueryContext } from '../../../contexts';

export const CustomPushDestinationsSection = () => {
  const { espAccountsBySendingPlatform, isLoadingEssentialData } =
    useSendingPlatformsQueryContext();

  let espAccounts = espAccountsBySendingPlatform[CUSTOM_PUSH] || [];
  espAccounts = [mockCustomPushAccount];

  if (isLoadingEssentialData) return <Skeleton height={265} />;

  if (!espAccounts.length) return <CustomPushDestinationsEmptyState />;

  return (
    <>
      {espAccounts.map((espAccount) => (
        <CustomPushDestination
          key={espAccount.id}
          espAccount={espAccount as EspAccountWithCustomMTAConfig}
        />
      ))}
    </>
  );
};
